import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  fonts,
  fontSizes,
  colors,
} from "@softmax/design-system/tokens.stylex";

function terminalWords(text: string) {
  return text.split(/(\s+)/).map((chunk, index) =>
    /\S/.test(chunk) ? (
      <span key={index} {...stylex.props(localStyles.word)}>
        {chunk}
      </span>
    ) : (
      chunk
    ),
  );
}

export function TerminalCommandLines({
  lines,
  agent,
  prompt,
}: Readonly<{
  lines: readonly [string, string];
  agent: string;
  prompt: string;
}>) {
  const binAt = lines[1].indexOf(`${agent} "`);
  return (
    <div {...stylex.props(localStyles.terminalBody)}>
      <div {...stylex.props(localStyles.terminalRow)}>
        <span aria-hidden="true" {...stylex.props(localStyles.shellPrompt)}>
          {prompt}
        </span>
        <p data-command-line {...stylex.props(localStyles.commandLine)}>
          {terminalWords(lines[0])}
        </p>
      </div>
      <div {...stylex.props(localStyles.terminalRow)}>
        <span aria-hidden="true" {...stylex.props(localStyles.shellPrompt)}>
          {prompt}
        </span>
        <p data-command-line {...stylex.props(localStyles.commandLine)}>
          {lines[1].slice(0, binAt)}
          <span {...stylex.props(localStyles.executable)}>{agent}</span>
          {terminalWords(lines[1].slice(binAt + agent.length))}
        </p>
      </div>
    </div>
  );
}

const localStyles = stylex.create({
  terminalBody: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space8,
    padding: spacing.space16,
  },
  terminalRow: { display: "flex", gap: spacing.space10, minWidth: 0 },
  shellPrompt: {
    userSelect: "none",
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    lineHeight: 1.6,
    color: colors.action,
  },
  commandLine: {
    minWidth: 0,
    flex: 1,
    margin: 0,
    paddingLeft: "2ch",
    textIndent: "-2ch",
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    lineHeight: 1.6,
    overflowWrap: "normal",
    color: colors.inverse,
  },
  word: {
    display: "inline-block",
    maxWidth: "100%",
    textIndent: 0,
    overflowWrap: "break-word",
  },
  executable: { fontWeight: 600 },
});
